import {
  Stack,
  Box,
  SportsEsportsIcon,
  VideocamIcon,
  ImageIcon,
  useTheme,
} from '@gogame/components';

function getIcon(type) {
  switch (type) {
    case 'app':
      return <SportsEsportsIcon fontSize={'inherit'} />;
    case 'video':
      return <VideocamIcon fontSize={'inherit'} />;
    case 'banner':
      return <ImageIcon fontSize={'inherit'} />;
    default:
      return null;
  }
}

const formatSeconds = (s) => {
  const [_, minute, second, sign] =
    s > 0
      ? [s / 3_600, (s / 60) % 60, s % 60, '']
      : [-s / 3_600, (-s / 60) % 60, -s % 60, '-'];

  return (
    sign +
    [minute, second].map((v) => `${Math.floor(v)}`.padStart(2, '0')).join(':')
  );
};

function getFormattedValue(value, type) {
  switch (type) {
    case 'time':
      return formatSeconds(value);
    default:
      return null;
  }
}

export const Attribute = ({ type, value, label }) => {
  const theme = useTheme();
  const icon = getIcon(type);
  const formattedValue = getFormattedValue(value, type);
  return (
    <Box
      sx={{
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '20px',
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.action.active,
        borderRadius: '6px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        padding: '2px 4px',
      }}
    >
      {icon && (
        <Box
          sx={{
            marginRight: '2px',
            width: 18,
            height: 18,
            // color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: '18px',
          }}
        >
          {icon}
        </Box>
      )}
      {formattedValue}
      {label}
    </Box>
  );
};

const Attributes = ({ children }) => {
  return (
    <Stack
      direction={'row'}
      spacing={0.5}
      sx={{
        p: '2px',
      }}
    >
      {children}
    </Stack>
  );
};

export default Attributes;
